<div *ngIf="store.rebalancing">
  <div
    #orderDetails
    class="mt-4 md:mt-8 text-sm text-gray-dark overflow-hidden transition-all duration-500"
  >
    <span class="font-bold">{{ 'rebalancing.orderDetails' | translate }}</span>
    <div class="mt-2">
      <common-rebalancing-order-details-estimations></common-rebalancing-order-details-estimations>
      <common-rebalancing-order-details-expirations></common-rebalancing-order-details-expirations>
      <common-rebalancing-price-compare></common-rebalancing-price-compare>
      <common-rebalancing-order-details-approvals
        *ngIf="store.type === RebalancingType.WALLET"
      ></common-rebalancing-order-details-approvals>
      <common-rebalancing-order-details-trades
        [trades]="store.rebalancing.trades"
      ></common-rebalancing-order-details-trades>
    </div>
  </div>
</div>
